var m = require('mithril');
var Promise = require('bluebird');
var heading = require('../../components/heading');
var button = require('../../components/button');
var modalForm = require('../../layout/components/modalForm');
var loaders = require('../../layout/components/loaders');
var Model = require('../../libs/Model');
var Draggable = require('../../libs/draggable');
var Report = require('../../../../../models/reports/report');
var reportEventPanel = require('./reportEventPanel');
var eventBindings = require('../../../../../models/reports/eventBindings');
var addEquipmentModal = require('./addEquipmentModal');
var reportAuxiliaryPoints = require('./reportAuxiliaryPoints');
var includesRecordForm = modalForm(require('../models/includesRecord'));
var reportSchemaColumns = require('../libs/reportSchemaColumns');
var ontologyFields = require('../../../../../models/equipment/ontologyFields');

var component = {};

function getReportTypeMeta(record) {
  var type = record && record.type ? record.type : 'Custom Export';
  return Report.getTypeMeta ? Report.getTypeMeta(type) : {};
}

function getEquipmentTableConfig(record) {
  var meta = getReportTypeMeta(record);
  var ui = meta && meta.ui ? meta.ui : {};
  return ui && ui.equipmentTable ? ui.equipmentTable : {};
}

function getEquipmentTableSections(record) {
  var config = getEquipmentTableConfig(record);
  if (Array.isArray(config && config.sections) && config.sections.length) {
    return config.sections;
  }
  return [config];
}

function getContainedEquipmentEdges(record, sectionConfig) {
  var reportEdges = eventBindings.getReportAttachmentEdges(record);
  var config = sectionConfig || getEquipmentTableConfig(record);
  var allowedClasses = Array.isArray(config && config.allowedClasses) && config.allowedClasses.length
    ? config.allowedClasses
    : [record && record.type].filter(Boolean);
  return sortEquipmentEdges(reportEdges.filter(function (edge) {
    return edge && edge.in && allowedClasses.indexOf(edge.in['@class']) >= 0;
  }));
}

function sortEquipmentEdges(edges) {
  return (Array.isArray(edges) ? edges.slice() : []).sort(function (a, b) {
    var aIndex = typeof (a && a.index) === 'number' ? a.index : Number(a && a.index);
    var bIndex = typeof (b && b.index) === 'number' ? b.index : Number(b && b.index);
    if (Number.isFinite(aIndex) && Number.isFinite(bIndex) && aIndex !== bIndex) {
      return aIndex - bIndex;
    }
    if (Number.isFinite(aIndex) && !Number.isFinite(bIndex)) return -1;
    if (!Number.isFinite(aIndex) && Number.isFinite(bIndex)) return 1;
    var aName = a && a.in && a.in.name ? String(a.in.name) : '';
    var bName = b && b.in && b.in.name ? String(b.in.name) : '';
    return aName.localeCompare(bName, undefined, { numeric: true, sensitivity: 'base' });
  });
}

function buildEquipmentColumns(record, sectionConfig) {
  var meta = getReportTypeMeta(record);
  var classDef = meta && meta.classDef;
  var config = sectionConfig || getEquipmentTableConfig(record);
  var excludeFields = Array.isArray(config.excludeFields)
    ? config.excludeFields
    : ['name', 'location'];

  if (Array.isArray(config.fields) && config.fields.length) {
    return reportSchemaColumns.buildFieldColumns(config.fields, {
      excludeFields: excludeFields
    });
  }

  return reportSchemaColumns.buildFieldColumnsFromClassDef(classDef, {
    excludeFields: excludeFields
  });
}

function isLocationRecord(equipmentRecord) {
  var className = equipmentRecord && equipmentRecord['@class'];
  return ['Site', 'Building', 'Level', 'Room'].indexOf(className) >= 0;
}

function buildRecordHref(equipmentRecord) {
  if (!equipmentRecord || !equipmentRecord['@rid']) return '';
  var rid = equipmentRecord['@rid'].slice(1);
  if (isLocationRecord(equipmentRecord)) {
    return '/location/' + rid;
  }
  return '/equipment/' + String(equipmentRecord['@class'] || '').toLowerCase() + '/' + rid;
}

function buildLocationPathLabel(equipmentRecord) {
  var path = Array.isArray(equipmentRecord && equipmentRecord.$path) ? equipmentRecord.$path.slice() : [];
  if (path.length > 1 && equipmentRecord && path[0] && path[0]['@rid'] === equipmentRecord['@rid']) {
    path = path.reverse();
  }

  if (path.length > 0) {
    var keepCurrentRecordInPath = isLocationRecord(equipmentRecord);
    return path
      .filter(function (segment) {
        if (keepCurrentRecordInPath) return true;
        return !(equipmentRecord && segment && segment['@rid'] && segment['@rid'] === equipmentRecord['@rid']);
      })
      .map(function (segment) {
        if (!segment) return '';
        var baseName = segment.name || segment['@class'] || '';
        return segment.roomNumber ? (baseName + ' ' + segment.roomNumber) : baseName;
      })
      .filter(Boolean)
      .join(' / ');
  }

  var linkedLocations = Array.isArray(equipmentRecord && equipmentRecord.out_containsLocation)
    ? equipmentRecord.out_containsLocation
    : [];
  if (linkedLocations.length > 0) {
    return linkedLocations
      .map(function (edge) {
        var locationRecord = edge && edge.in;
        if (!locationRecord) return '';
        var baseName = locationRecord.name || locationRecord['@class'] || '';
        return locationRecord.roomNumber ? (baseName + ' ' + locationRecord.roomNumber) : baseName;
      })
      .filter(Boolean)
      .join(', ');
  }

  return equipmentRecord && equipmentRecord.location ? String(equipmentRecord.location) : '';
}

function renderEquipmentValue(equipmentRecord, columnDef) {
  var fieldDef = {
    name: columnDef && columnDef.fieldName,
    kind: columnDef && columnDef.kind,
    defaultUnit: columnDef && columnDef.defaultUnit
  };
  return m('td.bb.bl-0.tc.ph2.pv2', equipmentRecord
    ? ontologyFields.getDisplayFieldValue(equipmentRecord, fieldDef)
    : '');
}

function applySortedEquipment(recordStream, orderedEdgeRids) {
  var record = recordStream();
  if (!record || !Array.isArray(record.out_ReportAttachment)) return;
  var orderedIndexByRid = new Map((orderedEdgeRids || []).map(function (rid, idx) {
    return [rid, idx];
  }));
  record.out_ReportAttachment.forEach(function (edge) {
    if (!edge || !edge['@rid']) return;
    if (orderedIndexByRid.has(edge['@rid'])) {
      edge.index = orderedIndexByRid.get(edge['@rid']);
    }
  });
  record.out_ReportAttachment = sortEquipmentEdges(record.out_ReportAttachment);
  recordStream(record);
}

function buildCombinedOrderedEdgeRids(record, sectionOverrides) {
  var overrides = sectionOverrides || {};
  var allEdges = sortEquipmentEdges(eventBindings.getReportAttachmentEdges(record));
  var sections = getEquipmentTableSections(record);
  var ordered = [];
  var used = new Set();

  sections.forEach(function (section) {
    var currentSectionEdges = getContainedEquipmentEdges(record, section);
    var desiredOrder = Array.isArray(overrides[section.key]) && overrides[section.key].length
      ? overrides[section.key]
      : currentSectionEdges.map(function (edge) { return edge && edge['@rid']; }).filter(Boolean);

    desiredOrder.forEach(function (rid) {
      if (!rid || used.has(rid)) return;
      if (!currentSectionEdges.some(function (edge) { return edge && edge['@rid'] === rid; })) return;
      used.add(rid);
      ordered.push(rid);
    });

    currentSectionEdges.forEach(function (edge) {
      if (!edge || !edge['@rid'] || used.has(edge['@rid'])) return;
      used.add(edge['@rid']);
      ordered.push(edge['@rid']);
    });
  });

  allEdges.forEach(function (edge) {
    if (!edge || !edge['@rid'] || used.has(edge['@rid'])) return;
    used.add(edge['@rid']);
    ordered.push(edge['@rid']);
  });

  return ordered;
}

function reloadReport(recordStream) {
  var record = recordStream();
  if (!record) return Promise.resolve();
  return loaders.requestWithLoader({
    loader: 'background',
    url: Model.urlForRecord(record),
    method: 'GET',
    background: true
  })
  .then(function (updatedRecord) {
    if (updatedRecord) {
      recordStream(updatedRecord);
      m.redraw();
    }
  });
}

function sortEquipment(recordStream, sectionConfig, rowNodes) {
  var sectionOrderedEdgeRids = Array.from(rowNodes || [])
    .map(function (node) {
      return node && node.id ? node.id : null;
    })
    .filter(Boolean);

  if (!sectionOrderedEdgeRids.length) {
    return Promise.resolve();
  }

  var record = recordStream();
  var orderedEdgeRids = buildCombinedOrderedEdgeRids(record, {
    [sectionConfig && sectionConfig.key ? sectionConfig.key : 'equipment']: sectionOrderedEdgeRids
  });

  applySortedEquipment(recordStream, orderedEdgeRids);
  m.redraw();

  return Promise.map(orderedEdgeRids, function (rid, idx) {
      return loaders.requestWithLoader({
        loader: 'background',
        url: '/api/v1/includesrecord/' + rid.slice(1),
        method: 'PUT',
        body: {
          index: idx
      },
      background: true
    });
  }, { concurrency: 1 })
  .then(function () {
    return reloadReport(recordStream);
  });
}

function renderEquipmentSection(recordStream, sectionConfig) {
  var record = recordStream();
  var equipmentEdges = getContainedEquipmentEdges(record, sectionConfig);
  var columns = buildEquipmentColumns(record, sectionConfig);
  var headingLabel = sectionConfig.heading || 'Equipment';
  var addLabel = sectionConfig.addLabel || ('Add ' + (record && record.type ? record.type : 'Equipment'));
  var showLocation = sectionConfig.showLocationPath !== false;

  return m('div', { key: sectionConfig.key || headingLabel }, [
    m(heading, {label: headingLabel, class: 'f1 mh3 pv2'}),
    equipmentEdges.length && (showLocation || columns.length) ? m('div.overflow-hidden.mb3.mh3', [
      m('div.overflow-auto', [
        m('table.w-100.f3.pr4.pb3.narrow', { style: { tableLayout: 'fixed' } }, [
          m('thead', [
            m('tr', [
              m('th.bb.bl-0.bw1.tc.ph2.pv2.fw1.w2'),
              m('th.bb.bl-0.bw1.tl.ph2.pv2.fw1', 'Name'),
              showLocation ? m('th.bb.bl-0.bw1.tl.ph2.pv2.fw1', 'Location') : null,
              columns.map(function (column, idx) {
                return m('th.bb.bl-0.bw1.tc.ph2.pv2.fw1', { key: column.id || idx }, column.name || column);
              }),
              m('th.bb.bl-0.bw1.tc.ph2.pv2.fw1', 'Actions')
            ])
          ]),
          m(Draggable, {
            onsort: sortEquipment.bind(null, recordStream, sectionConfig),
            draggable: '.report-equipment-row',
            handleClass: '.report-equipment-drag-handle',
            htmlElement: 'tbody'
          }, equipmentEdges.map(function (containsEdge) {
            var equipmentRecord = containsEdge.in;
            return m('tr.report-equipment-row', { id: containsEdge['@rid'], key: containsEdge['@rid'] || equipmentRecord['@rid'] }, [
              m('td.bb.bl-0.tc.ph2.pv2', [
                m('i.ion-android-menu.blue.pointer.report-equipment-drag-handle', {
                  style: { cursor: 'grab' }
                })
              ]),
              m('td.bb.bl-0.ph2.pv2', [
                equipmentRecord && equipmentRecord['@rid']
                  ? m(m.route.Link, {
                      href: buildRecordHref(equipmentRecord)
                    }, equipmentRecord.name || equipmentRecord['@rid'])
                  : (equipmentRecord.name || '')
              ]),
              showLocation ? m('td.bb.bl-0.ph2.pv2', buildLocationPathLabel(equipmentRecord)) : null,
              columns.map(function (column) {
                return renderEquipmentValue(equipmentRecord, column);
              }),
              m('td.bb.bl-0.tc.ph2.pv2', [
                m('i.ion-ios-trash.red.pointer', {
                  onclick: includesRecordForm.deleteDialogue.bind(
                    includesRecordForm,
                    Object.assign({}, containsEdge, { customDeleteTitle: 'Remove Equipment' })
                  )
                })
              ])
            ]);
          }))
        ])
      ])
    ]) : null,
    m('div.mh3.mb3', [
      m(button, {
        label: addLabel,
        class: 'w5',
        func: addEquipmentModal.editDialogue.bind(addEquipmentModal, record, {
          recordStream: recordStream,
          equipmentTable: sectionConfig
        })
      })
    ])
  ]);
}

component.view = function reportEquipmentTableBuildView(vnode) {
  var recordStream = vnode.attrs.record;
  var record = recordStream();
  var sections = getEquipmentTableSections(record);
  var showEventPanel = vnode.attrs.showEventPanel !== false;
  var showAuxiliaryPoints = vnode.attrs.showAuxiliaryPoints !== false;

  return m('div', [
    showEventPanel ? m(reportEventPanel, {record: record, showLocation: false}) : null,
    sections.map(function (sectionConfig) {
      return renderEquipmentSection(recordStream, sectionConfig);
    }),
    showAuxiliaryPoints ? m(reportAuxiliaryPoints, {
      record: recordStream
    }) : null
  ]);
};

component.__testables = {
  buildCombinedOrderedEdgeRids: buildCombinedOrderedEdgeRids,
  getContainedEquipmentEdges: getContainedEquipmentEdges,
  buildEquipmentColumns: buildEquipmentColumns,
  buildLocationPathLabel: buildLocationPathLabel,
  buildRecordHref: buildRecordHref,
  getEquipmentTableConfig: getEquipmentTableConfig,
  getEquipmentTableSections: getEquipmentTableSections,
  sortEquipmentEdges: sortEquipmentEdges
};

module.exports = component;
